/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { pricesControllerCreatePrice } from '../fn/prices/prices-controller-create-price';
import { PricesControllerCreatePrice$Params } from '../fn/prices/prices-controller-create-price';
import { pricesControllerGetPrice } from '../fn/prices/prices-controller-get-price';
import { PricesControllerGetPrice$Params } from '../fn/prices/prices-controller-get-price';
import { pricesControllerGetPrices } from '../fn/prices/prices-controller-get-prices';
import { PricesControllerGetPrices$Params } from '../fn/prices/prices-controller-get-prices';
import { pricesControllerUpdatePrice } from '../fn/prices/prices-controller-update-price';
import { PricesControllerUpdatePrice$Params } from '../fn/prices/prices-controller-update-price';

@Injectable({ providedIn: 'root' })
export class PricesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pricesControllerCreatePrice()` */
  static readonly PricesControllerCreatePricePath = '/keus-payments/prices';

  /**
   * Create a new price.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricesControllerCreatePrice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricesControllerCreatePrice$Response(params: PricesControllerCreatePrice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pricesControllerCreatePrice(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new price.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricesControllerCreatePrice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricesControllerCreatePrice(params: PricesControllerCreatePrice$Params, context?: HttpContext): Observable<void> {
    return this.pricesControllerCreatePrice$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pricesControllerGetPrice()` */
  static readonly PricesControllerGetPricePath = '/keus-payments/prices/{priceId}';

  /**
   * Get a price.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricesControllerGetPrice()` instead.
   *
   * This method doesn't expect any request body.
   */
  pricesControllerGetPrice$Response(params: PricesControllerGetPrice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pricesControllerGetPrice(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a price.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricesControllerGetPrice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pricesControllerGetPrice(params: PricesControllerGetPrice$Params, context?: HttpContext): Observable<void> {
    return this.pricesControllerGetPrice$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pricesControllerUpdatePrice()` */
  static readonly PricesControllerUpdatePricePath = '/keus-payments/prices/{priceId}';

  /**
   * Update a price.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricesControllerUpdatePrice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricesControllerUpdatePrice$Response(params: PricesControllerUpdatePrice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pricesControllerUpdatePrice(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a price.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricesControllerUpdatePrice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricesControllerUpdatePrice(params: PricesControllerUpdatePrice$Params, context?: HttpContext): Observable<void> {
    return this.pricesControllerUpdatePrice$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pricesControllerGetPrices()` */
  static readonly PricesControllerGetPricesPath = '/keus-payments/prices/filter';

  /**
   * Get all prices.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricesControllerGetPrices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricesControllerGetPrices$Response(params: PricesControllerGetPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pricesControllerGetPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all prices.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricesControllerGetPrices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricesControllerGetPrices(params: PricesControllerGetPrices$Params, context?: HttpContext): Observable<void> {
    return this.pricesControllerGetPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
